import React from 'react';
import {MdChevronLeft} from 'react-icons/md';

import styled from '../../theme/styled';

interface MinimizeProps {
    direction: string;
    onClick: () => void;
}

const MinimizeContainer = styled.div`
    background-color: ${props => props.theme.colors.brand[2]};
    cursor: pointer;
    height: ${props => props.theme.sizes.panel.height * 0.8}px;
    top: ${props => props.theme.sizes.panel.height * 0.1}px;
    position: absolute;
    width: 60px;
    transition: all 0.35s;
    z-index: -1;
    &.direction_left {
        left: -30px;
    }
    .circle {
        margin: ${props => props.theme.sizes.panel.height * 0.05}px;
        height: ${props => props.theme.sizes.panel.height * 0.7}px;
        width: ${props => props.theme.sizes.panel.height * 0.7}px;
        svg{
            width: 42px;
            height: 42px;
        }
    }
    @media(min-width: 764px) {
        .circle {
            background-color: ${props => props.theme.colors.brand[2]};
            border-radius: 50%;
            svg{
                fill: #fff;
            }
        }
        &.direction_left {
            box-shadow: ${props => props.theme.components.right_panel.shadow};
            border-radius: 50px 0 0 50px;
            border-right: 1px solid ${props => props.theme.colors.border};
            .circle {
                svg {
                    transform: rotate(180deg);
                }
            }
        }
        &.direction_right {
            box-shadow: ${props => props.theme.components.left_panel.shadow};
            border-radius: 0 50px 50px 0;
            border-left: 1px solid ${props => props.theme.colors.border};
            right: -30px;
            .circle {
                float: right;
            }
        }
        &:HOVER{
            background-color: ${props => props.theme.colors.background};
            .circle{
                background-color: ${props => props.theme.colors.brand[1]};
            }
            &.direction_left {
                left: -60px;
            }
            &.direction_right {
                right: -60px;
            }
        }
    }
    @media(max-width: 764px) {
        z-index: 1;
        left: 0;
        width: 40px;
        background-color: transparent;
        box-shadow: none;
        border: none;
        &.direction_left {
            left: 0;
        }
        &.direction_right {
            right: 0;
        }
    }
`;

const Minimize = (props: MinimizeProps) => {
    return (
        <MinimizeContainer className={`direction_${props.direction}`} onClick={props.onClick}>
            <div className="circle">
                <MdChevronLeft/>
            </div>
        </MinimizeContainer>
    );
};

export default Minimize;



// WEBPACK FOOTER //
// ./src/components/base/Minimize.tsx